import React, { useState } from 'react';
// import useRetrieveProducts from '../../../hooks/products';
// import useRetrieveProductsGraphQL from '../../../hooks/products';
import Loader from '../loader';
import ProductCard from '../productCard';
// import CustomButton from '../../customButton';
import CustomModal from '../customModal';
import useGetProductsBySupplier from '../../hooks/productsBySupplier';

export function CeletteProdukter() {

    const {products, isLoading, isError} = useGetProductsBySupplier(9);
    const [selectedFilters,setSelectedFilters] = useState({});

    const updateFilters = (newFilters) => {
        setSelectedFilters(newFilters);
    }



    if(isLoading) {
        return <div><Loader /></div>
    }

    if(isError) {
        return <div>Oida, her har det skjedd noe feil</div>
    }


    const filteredProducts = products.filter((product) => {
        const productCategory = product.attributes.category.data.attributes.place;
      
        return Object.keys(selectedFilters).some((filterKey) => {
          return selectedFilters[filterKey] && productCategory === filterKey;
        });
      });
      
      let finalProducts = [];
      
      if (filteredProducts.length > 0) {
        finalProducts = filteredProducts;
      } else {
        finalProducts = products;
      }

      finalProducts.sort((a, b) => {
        const nameA = a.attributes.varenummer ? a.attributes.varenummer.toLowerCase() : '';
        const nameB = b.attributes.varenummer ? b.attributes.varenummer.toLowerCase() : '';
    
        if (!nameA || !nameB) {
            return nameA.localeCompare(nameB);
        }
    
        if (isNaN(nameA) || isNaN(nameB)) {
            return nameA.localeCompare(nameB);
        }
    
        return Number(nameA) - Number(nameB);
    });

    return ( 
        <div>
            <h1 className="my-3">Våre produkter fra Celette!</h1>
            <div className="d-flex">
                <div className="d-none  col-2">
                    <p className=''>Kategori: Rette og løfteutstyr</p>
                    <p>Leverandør: Königstein</p>
                </div>
                <div className="col-12 col-md-10 m-auto">
                    <div className='d-md-none'>
                        <CustomModal
                            buttonTitle="Filter"
                            title="Filter"
                            body="her må filterskjemaet komme"
                            updateFilters={updateFilters}
                        />
                    </div>
                    <div className="row d-flex mx-0 flex-wrap justify-content-center">
                        {finalProducts.map((product) => (
                            <div key={product.id} className="col-md-5 col-lg-3 col-9 mx-2 mb-4">
                                <ProductCard key={product.id} product={product} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default CeletteProdukter;